import React, { Component } from "react";
import { hot } from "react-hot-loader";
import { Route, withRouter, Switch } from "react-router-dom";
//import Test from "./pages/test/Test";
// import Get from "./pages/getVip/Get";
import GetVip from "./pages/getVipBySign/Get";
import Success from "./pages/getVip/Success";

@withRouter
class Routes extends Component {
  componentDidMount() {
    console.log("router mounted");
  }
  render() {
    return (
      <Switch>
        {/* <Route path="/test" component={Test} exact /> */}
        <Route path="/experience-vip/success" component={Success} exact />{" "}
        {/* <Route path="/get-vip-by-sign/get" component={GetVip} exact/> */}
        <Route component={GetVip} />
      </Switch>
    );
  }
}

export default hot(module)(Routes);



// WEBPACK FOOTER //
// ./src/Routes.js